import Head from "next/head"
import React from "react"
import styled, { css } from "styled-components"

import CtaLink from "~/components/atoms/CtaLink"
import Typography from "~/components/atoms/Typography"
import { Container } from "~/components/layouts/Container"
import TextCut from "~/components/molecules/TextCut"
import Breadcrumb from "~/components/organisms/Breadcrumb"
import Footer from "~/components/organisms/Footer"
import Header from "~/components/organisms/Header"
import SeminarHead from "~/components/organisms/SeminarHead"
import SeminarSchduleCard from "~/components/organisms/SeminarSchduleCard"
import Table from "~/components/organisms/Table"
import { SpacingSize, Color, TextSize, LineHeight, IsPC, IsMobile, Z } from "~/consts/style-mixins"
import { staticPath, internalLink } from "~/services/helper"

export default class SeminarDetail extends React.Component {
  render() {
    const crumbs = [
      {
        name: "就活セミナー・就活対策講座一覧",
        link: internalLink(`/seminars`),
      },
      {
        name: `就活の進め方講座`,
        link: internalLink(`/seminars/4`),
      },
    ]

    return (
      <>
        <Head>
          <title>就活の進め方講座 | Infra（インフラ）</title>
          <meta
            name="description"
            content={`いよいよ就職活動も本格化してきました。このセミナーでは、近年の就職活動の流れから、将来を見据えた企業の選び方、早期内定を獲得するコツまでを徹底解説いたします。将来性を考えて安定した仕事に就きたい、仕事とプライベートを両立させて自分らしい人生を送りたいと考えるひとも多いのではないのでしょうか。長く働くことが当たり前の現代だからこそ、AIやテクノロジーに取って変わられないキャリアの築き方を学びましょう。`}
          />
          <meta property="og:title" content="就活の進め方講座 | Infra（インフラ）" />
          <meta
            property="og:description"
            content="いよいよ就職活動も本格化してきました。このセミナーでは、近年の就職活動の流れから、将来を見据えた企業の選び方、早期内定を獲得するコツまでを徹底解説いたします。将来性を考えて安定した仕事に就きたい、仕事とプライベートを両立させて自分らしい人生を送りたいと考えるひとも多いのではないのでしょうか。長く働くことが当たり前の現代だからこそ、AIやテクノロジーに取って変わられないキャリアの築き方を学びましょう。"
          />
          <meta property="og:image" content={`${process.env.APP_HOST + staticPath("/static/images/ogp.png")}`} />
        </Head>
        <Header logoType="Plain" />
        <StyledContainerWrapper>
          <Container size="Medium">
            <SeminarHead title="就活の進め方講座" bgSrc={staticPath("/static/images/seminar/seminars-4.png")} isClose />
            <div>
              <StyledSchduleCardWrapper>
                <SeminarSchduleCard
                  date="12/17（火）"
                  timeStart="19:30"
                  timeEnd="21:00"
                  applicationNum={30}
                  capacityNum={30}
                />
              </StyledSchduleCardWrapper>
              <StyledEachItemWrapper>
                <TextCut cutPoint={240} size="Medium">
                  {`いよいよ就職活動も本格化してきました。このセミナーでは、近年の就職活動の流れから、将来を見据えた企業の選び方、早期内定を獲得するコツまでを徹底解説いたします。将来性を考えて安定した仕事に就きたい、仕事とプライベートを両立させて自分らしい人生を送りたいと考えるひとも多いのではないのでしょうか。長く働くことが当たり前の現代だからこそ、AIやテクノロジーに取って変わられないキャリアの築き方を学びましょう。`}
                </TextCut>
              </StyledEachItemWrapper>
              <StyledEachItemWrapper>
                <StyledHeading type="SubHero">当日の内容</StyledHeading>
                <TextCut cutPoint={240} size="Medium">
                  {`◾️ 就活の流れ\n◾️ 自己分析の方法\n◾️ 企業の絞り方\n・人生100年時代の働き方\n・仕事の選び方\n・業界毎の伸び率\n◾️ 個別就活アドバイス\n・合った企業のご紹介`}
                </TextCut>
              </StyledEachItemWrapper>
              <StyledEachItemWrapper>
                <StyledHeading type="SubHero">こんな方におすすめ</StyledHeading>
                <TextCut cutPoint={240} size="Medium">
                  {`・今の時代にあった就職活動の進め方を知りたい方\n・将来性のある仕事に就いて、手に職を持って働きたい方\n・自分に合った企業を見つけたい方\n・結婚や育児などのライフイベントに合わせた働き方をしたい方`}
                </TextCut>
              </StyledEachItemWrapper>
              <StyledTableWrapper>
                <StyledHeading type="SubHero">開催概要</StyledHeading>
                <Table
                  items={[
                    {
                      name: "対象",
                      content: "2021年3月までに大学院・大学を卒業または卒業見込みの方",
                    },
                    {
                      name: "参加費",
                      content: "無料",
                    },
                    {
                      name: "参加特典",
                      content: "Infraのキャリアアドバイザーが本選考内定までサポート",
                    },
                    {
                      name: "持ち物",
                      content: "筆記用具・ノート",
                    },
                    {
                      name: "服装",
                      content: "自由。ラフな格好で構いません。",
                    },
                  ]}
                />
              </StyledTableWrapper>
              <StyledEachItemWrapper>
                <StyledHeading type="SubHero">開催場所</StyledHeading>
                <StyledPlace>渋谷・恵比寿周辺</StyledPlace>
                <StyledAddress>※お申込み後に詳細をご連絡いたします</StyledAddress>
              </StyledEachItemWrapper>
            </div>
          </Container>
        </StyledContainerWrapper>
        <Breadcrumb crumbs={crumbs} />
        <ActionWrapper className="gtm_seminar-apply">
          <CtaLink size="Medium" href={``} disabled>
            募集は終了しました
          </CtaLink>
        </ActionWrapper>
        <Footer />
      </>
    )
  }
}

const StyledContainerWrapper = styled.div`
  ${IsPC(css`
    padding: 48px 0;
  `)}
  ${IsMobile(css`
    padding: 24px 0 32px;
  `)}
`
const StyledEachItemWrapper = styled.div`
  margin-bottom: ${SpacingSize["2XL"]}px;
  &:last-child {
    margin-bottom: 0;
  }
`
const StyledHeading = styled(Typography)`
  margin-bottom: ${SpacingSize.XS}px;
  color: ${Color.Primary};
`
const StyledTableWrapper = styled.div`
  margin: 16px 0 32px;
`
const StyledPlace = styled.div`
  margin-bottom: ${SpacingSize["3XS"]}px;
  font-size: ${TextSize.M}px;
  font-weight: bold;
  line-height: ${LineHeight.M}%;
`
const StyledAddress = styled.div`
  line-height: ${LineHeight.M}%;
  color: ${Color.Gray};
  font-size: ${TextSize.S}px;
`
const StyledSchduleCardWrapper = styled.div`
  margin-top: ${SpacingSize.XL}px;
  margin-bottom: ${SpacingSize["XL"]}px;
`
const ActionWrapper = styled.div`
  text-align: center;
  width: 100%;
  max-width: 480px;
  position: fixed;
  bottom: 16px;
  z-index: ${Z.Child};
  ${IsPC(css`
    left: 50%;
    margin-left: -240px;
  `)}
  ${IsMobile(css`
    padding: 0 16px;
    max-width: none;
    left: 0;
    margin-left: 0;
  `)}
`
